import { useState } from 'react';

const usePriceField = () => {
  const [recurrenceString, setRecurrence] = useState('');
  const recurrence = parseFloat(recurrenceString.replace(',', '.')) || 1;

  return {
    recurrence, setRecurrence,
  };
};

export default usePriceField;
